import { defineRouting } from 'next-intl/routing';
import overseaConfig from '@/config/oversea.generated.json';

import type { Locale } from './locales';

const locales = overseaConfig.i18n.locales as Locale[];
const defaultLocale = overseaConfig.i18n.defaultLocale as (typeof locales)[number];

export const routing = defineRouting({
  locales,
  defaultLocale,
  localeDetection: false,
  localePrefix: overseaConfig.i18n.localePrefix as 'never',
});

export type { Locale } from './locales';
